import _convertToPlainTextCustom from "../functions/quill/convertToPlainTextCustom.js";
import _convertToHtml from "../functions/quill/convertToHtml.js";
import _eol from "eol";
import _removeInvalidEvents from "../functions/eventGroups/removeInvalidEvents.js";
import _tcLib from "../lib/timecode.js";
import _Event from "../classes/event.js";
const Event = _Event;
const tcLib = _tcLib;
const removeInvalidEvents = _removeInvalidEvents;
const eol = _eol;
const convertToHtml = _convertToHtml;
const convertToPlainTextCustom = _convertToPlainTextCustom;
export default {
  decode: function (input, options) {
    let subEvent,
      start,
      end,
      events = [],
      lineChunkArray,
      subtitleText,
      primaryOpt,
      secondaryOpt;
    eol.split(input).forEach(fileLine => {
      try {
        if (!fileLine) {
          return;
        }
        subEvent ? subEvent.text += "\n" : null;
        fileLine.split(/\t+/).forEach((lineChunk, count) => {
          let char = "",
            cache = "";
          if (!lineChunk || count === 0 && lineChunk.match(/\d+/)) {
            return;
          }
          if (lineChunk.match(/\d+\/\d+/)) {
            if (subEvent) {
              if (subEvent.italics) {
                let subtitleText = "";
                subEvent.text.split("\n").forEach(textLine => {
                  textLine ? subtitleText += `<em>${textLine}</em>\n` : null;
                });
                subEvent.text = subtitleText;
              }
              subEvent.text = convertToHtml(subEvent.text);
              events.push(subEvent);
            }
            start = lineChunk.split("/")[0].replace(/(.{2})(?!$)/g, "$1:");
            end = lineChunk.split("/")[1].replace(/(.{2})(?!$)/g, "$1:");

            //console.log(start, end);
            subEvent = new Event({
              start: tcLib.tcToSec(start, options.frameRate, options.dropFrame),
              end: tcLib.tcToSec(end, options.frameRate, options.dropFrame),
              text: "",
              yOffset: options.window.height * -0.10
            });
          } else if (subEvent) {
            lineChunkArray = lineChunk.split("");
            while (lineChunkArray.length > 0) {
              char = lineChunkArray.shift();
              if (char === "＠") {
                if (cache.length > 0) {
                  cache += char;
                  /* process cache */
                  //console.log(cache);
                  if (cache.split("｜").length === 2) {
                    cache = cache.match(/(?<=［).+(?=］)/)[0];
                    primaryOpt = cache.split("｜")[0];
                    secondaryOpt = cache.split("｜")[1];
                    if (secondaryOpt.match(/・+/g)) {
                      subEvent.text += `<strong>${primaryOpt}</strong>`;
                    } else {
                      subEvent.text += ` ${primaryOpt}(${secondaryOpt}) `;
                    }
                  } else if (cache.match(/(?<=［).+(?=］)/g)) {
                    subEvent.text += cache.match(/(?<=［).+(?=］)/g)[0];
                  }
                  cache = "";
                } else {
                  /* continue to build the cache */
                  cache += char;
                }
              } else if (cache.length > 0) {
                cache += char;
              } else {
                subEvent.text += char;
              }
            }
            /* cached commands */
            if (cache === "＠行頭") {
              subtitleText = subEvent.text.split("\n").filter(textLine => {
                return textLine;
              });
              subtitleText[subtitleText.length - 1] = "[" + subtitleText[subtitleText.length - 1] + "]";
              subEvent.text = subtitleText.join("\n");
            } else if (cache.match(/＠斜/)) {
              subEvent.italics = true;
            } else if (cache.match(/＠縦右/)) {
              subEvent.vertical = true;
              subEvent.xPos = 'end';
              subEvent.yPos = 'start';
            } else if (cache.match(/＠縦左/)) {
              subEvent.vertical = true;
              subEvent.xPos = 'start';
              subEvent.yPos = 'start';
            }
          }
        });
      } catch (err) {
        console.log(err, err.message);
      }
    });
    return events;
  },
  encode: function (eventGroup, options) {
    let output = "";

    // Get scene name from encode options, default to "Untitled"
    let sceneNameOption = options.encode ? options.encode.find(opt => opt.name === "Scene Name") : null;
    let sceneName = sceneNameOption ? sceneNameOption.selected || "Untitled" : "Untitled";

    // Build header line: Lambda<キャプション>V4\tDF{0|1}+1\tSCENE"{sceneName}"
    let dropFrameFlag = options.dropFrame ? "1" : "0";
    output += `Lambda<キャプション>V4\tDF${dropFrameFlag}+1\tSCENE"${sceneName}"\n`;

    // Process each event
    eventGroup.events.forEach((event, index) => {
      let eventId = index + 1;

      // Convert timecodes to HHMMSSFF format (no separators)
      let startTc = tcLib.secToTc(event.start, options.frameRate, options.dropFrame).replace(/[:;]/g, "");
      let endTc = tcLib.secToTc(event.end, options.frameRate, options.dropFrame).replace(/[:;]/g, "");

      // Detect italics before converting to plain text
      let hasItalics = /<em>/i.test(event.text);

      // Check for vertical positioning
      let isVerticalRight = event.vertical && event.xPos === "end";
      let isVerticalLeft = event.vertical && event.xPos === "start";

      // Convert HTML to plain text (this normalizes line breaks)
      let plainText = convertToPlainTextCustom(event.text, "\n", true);

      // Build formatting codes
      let formatCodes = [];
      if (isVerticalRight) {
        formatCodes.push("＠縦右");
      } else if (isVerticalLeft) {
        formatCodes.push("＠縦左");
      }
      if (hasItalics) {
        formatCodes.push("＠斜");
      }

      // Split text into lines
      let textLines = plainText.split("\n").filter(line => line.trim());

      // Build event output
      // First line: id\tstart/end\ttext\tformatCodes
      let firstLine = textLines[0] || "";
      let formatCodesStr = formatCodes.length > 0 ? "\t" + formatCodes.join("\t") : "";
      output += `${eventId}\t${startTc}/${endTc}\t${firstLine}${formatCodesStr}\n`;

      // Continuation lines: \t\t\t\ttext
      for (let i = 1; i < textLines.length; i++) {
        output += `\t\t\t\t${textLines[i]}\n`;
      }
    });
    return output.trim();
  },
  preProcess: {
    encode: function (eventGroup) {
      return removeInvalidEvents(eventGroup);
    },
    decode: function (input) {
      return eol.lf(input).trim();
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup) {
      return eventGroup;
    }
  }
};